import React, { Component } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { Button } from "antd";
import sentGAEvent from "@/ga";
import AudioCutAndSpeedAndVolumeWork from "./children/AudioCutAndSpeedAndVolumeWork";
import "@/assets/audioCutSpeedVolume.less";

class AudioCutAndSpeedAndVolume extends Component {
  constructor(props) {
    super(props);
    this.state = {
      workPlaceVisible: false,
    };
  }

  render() {
    const { t, work } = this.props;
    return (
      <div className="AudioCutSpeedVolume">
        {!this.state.workPlaceVisible ? (
          <div className="audio-work-hd">
            <h1 className="container">
              {work === "audioCut"
                ? t("HitPaw Online Audio Cutter")
                : work === "audioVolume"
                ? t("HitPaw Online Volume Changer")
                : t("HitPaw Online Audio Speed Changer")}
            </h1>
            <p className="container">
              {work === "audioCut"
                ? t("Trim or cut any audio files online.")
                : work === "audioVolume"
                ? t("Turn up or Turn down the volume of audio.")
                : t("Speed up or slow down audios online easily.")}
            </p>
            <Button
              size="large"
              onClick={() => {
                this.setState({ workPlaceVisible: true });
                sentGAEvent({
                  category: work === "audioCut" ? "audio_cut_page" : work === "audioVolume" ? "audio_volume_page" : "audio_speed_page",
                  action:
                    work === "audioCut" ? "audio_cut_start_click" : work === "audioVolume" ? "audio_volume_start_click" : "audio_speed_start_click",
                });
              }}
            >
              {t("common:Get Started")}
            </Button>
          </div>
        ) : (
          <AudioCutAndSpeedAndVolumeWork />
        )}
      </div>
    );
  }
}

const mapStateToPropos = state => ({
  work: state.work.work,
});

export default connect(mapStateToPropos)(withTranslation(["audioCutAndSpeedAndVolume", "common"])(AudioCutAndSpeedAndVolume));
